import * as types from '../actions/types'
import Immutable from 'immutable'

import { isPrimitive, parametro, parametroConfig } from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
	
	delegados: [],
	page: 1,
	showRecords: 50,
	totalRecords: 5,
	orderBy: {
		field: null,
		asc: false
	},
	modalAddDelegado: {
		show: false,
		title: "",
		action: "create",
		data: {
			responsable_cenco: '',
			cenco: '',
            tipo_solicitud: [],
            delegado: '',
			guid: '',
		},
		btnDisabled: false
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	}
})

export default function (state = INITIAL_STATE, action) {
	switch(action.type) {
		case types.OBTENER_DELEGADOS:
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords)
			action.payload.data = action.payload.data.map(ele => {ele.tipo_solicitud = ele.tipo_solicitud.split(","); return ele})
			return state.set('delegados', Immutable.fromJS(action.payload.data))
		case types.MOSTRAR_MODAL_ADICIONAR_DELEGADOS:
			state = state.setIn(['modalAddDelegado', 'show'], action.payload.show)
			state = state.setIn(['modalAddDelegado', 'title'], action.payload.title)

			if (action.payload.id) {
				const data = state.get('delegados').filter(x => x.get('id')===action.payload.id).get(0)
				state = state.setIn(['modalAddDelegado', 'data'], data)
			}
			return state.setIn(['modalAddDelegado', 'action'], action.payload.action)
		case types.CONMUTAR_SELECCION_DELEGADOS:
			return state.setIn(['delegados', action.payload.index, 'checked'], action.payload.checked)
		case types.CONMUTAR_SELECCION_TODOS_DELEGADOS:
			state.get('delegados').forEach((x, n) => {
				state = state.setIn(['delegados', n, 'checked'], action.payload.checked)
			})
			return state
		case types.MODIFICAR_INPUTS_DELEGADOS:
			if (isPrimitive(action.payload.value)) {
				state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
			} else {
				if (action.payload.immutable === false) {
					state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
				} else {
					state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
				}
			}
			
			return state
		case types.ORDENAR_DELEGADOS:
			return state.set('orderBy', action.payload.orderBy)
		case types.CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS:
			return state.set('showRecords', action.payload)
		case types.RESET_MODAL_ADD_DELEGADO:
			return state.setIn(["modalAddDelegado", "data"], INITIAL_STATE.getIn(["modalAddDelegado", "data"]))
		case types.SELECCIONAR_TIPO_SOLICITUD:
			if (action.payload.check){
				return state.updateIn(["modalAddDelegado", "data", "tipo_solicitud"], l => l.push(action.payload.tipo_solicitud))
			} else {
				return state.updateIn(["modalAddDelegado", "data", "tipo_solicitud"], l => l.filter(ele => ele !== action.payload.tipo_solicitud))
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/delegados.js